import { createAndAddCollaborator } from 'features/access/api/personneMoraleAccessApi';
import { CollaboratorCreationResult, CollaboratorDraft } from './collaboratorTypes';

/**
 * Crée séquentiellement les collaborateurs additionnels d'une PM via les
 * endpoints PersonneMoraleAccess existants (compte ABP minimal + accès cabinet,
 * mot de passe temporaire généré côté backend, rôle ABP selon la nature de la PM).
 *
 * Non atomique volontairement : chaque échec est remonté individuellement et
 * rattrapable dans la fiche PM → Collaborateurs.
 */
export async function createCollaboratorsForPm(
  personneMoraleId: string,
  drafts: CollaboratorDraft[],
): Promise<CollaboratorCreationResult[]> {
  const results: CollaboratorCreationResult[] = [];

  for (const draft of drafts) {
    try {
      const response = await createAndAddCollaborator(personneMoraleId, {
        email: draft.email,
        firstName: draft.firstName,
        lastName: draft.lastName,
        isOwner: draft.isOwner,
      });

      results.push({
        email: draft.email,
        firstName: draft.firstName,
        lastName: draft.lastName,
        success: response.isSuccess === true,
        temporaryPassword: response.data?.temporaryPassword,
        error: response.isSuccess ? undefined : response.errorMessage ?? 'Erreur inconnue',
      });
    } catch (error) {
      results.push({
        email: draft.email,
        firstName: draft.firstName,
        lastName: draft.lastName,
        success: false,
        error: 'Erreur lors de la création du compte',
      });
    }
  }

  return results;
}
